'use strict';

import '../../sass/index.scss';
import { UrlQuery } from './utils/urlQuery';

// tslint:disable-next-line:no-var-requires no-require-imports
const vrHotspots: IFragmentHotspots[] = require('../../hotspots.json');

interface IFragmentHotspots {
  readonly fragment: string;
  readonly default_yaw: number;
  readonly hotspots: IHotspot[];
  readonly texts?: IText[];
}

interface IText {
  readonly text: string;
  readonly color: string;
  readonly pitch: number;
  readonly yaw: number;
  readonly distance: number;
}

interface IHotspot {
  readonly fragment: string;
  readonly pitch: number;
  readonly yaw: number;
  readonly radius: number;
  readonly distance: number;
}

function handleVrHotspotClick(e: { id: string; }): void {
  if (!e.id || !vrView) {
    return;
  }

  const scene = vrHotspots.find((item) => item.fragment === e.id);

  if (!scene) {
    return;
  }

  vrView.setContent({
    image: `/fragments/${scene.fragment}.jpg`,
    default_yaw: scene.default_yaw
  });
}

function handleVrSceneChange(e: { image: string; }): void {
  if (!e.image || !vrView) {
    return;
  }

  const image = e.image;
  const imageWithoutPath = image.substr(image.lastIndexOf('/') + 1);
  const imageFilenameWithoutExtension = imageWithoutPath.split('.')[0];
  const scene = vrHotspots.find((item) => imageFilenameWithoutExtension === item.fragment);

  if (!scene) {
    return;
  }

  // Add all the hotspots for the scene
  for (const hotspot of scene.hotspots) {
    const { pitch, yaw, radius, distance, fragment } = hotspot;

    vrView.addHotspot(fragment, {
      pitch,
      yaw,
      radius,
      distance
    });
  }

  // Add all the texts for the scene
  for (const text of scene.texts || []) {
    vrView.addText(text);
  }
}

const urlFragment = UrlQuery.getParam('fragment');

if (!urlFragment) {
  const message = `Missing url "?fragment=X" parameter value.`;

  $(document.body)
    .append($('<h4 />', {
      text: message,
      css: {
        margin: 30,
        padding: 30,
        textAlign: 'center',
        background: 'red',
        color: 'white'
      }
    }));

  throw new Error(message);
}

const initialImage = `/fragments/${urlFragment}.jpg`;
const parameters: VRView.InitPlayerParameters = {
  image: initialImage,
  width: '100%',
  height: '100%',
  is_autopan_off: true,
  is_vr_off: false
};

const vrView = new VRView.Player('#vrview', parameters);

vrView.on('click', handleVrHotspotClick);
vrView.on('sceneloaded', handleVrSceneChange);
handleVrSceneChange({ image: initialImage });



// WEBPACK FOOTER //
// ./src/typescripts/client/index.ts